document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.pros-section__wrapper').forEach(function (slider) {
        const scrollDirection = slider.getAttribute('data-scroll-direction') || 'ltr';
        const baseSpeed = 0.5;
        // Negative speed for right-to-left direction (backward)
        const speed = scrollDirection === 'rtl' ? -baseSpeed : baseSpeed;
        
        new Splide(slider, {
            type: 'loop',
            pagination: false,
            arrows: false,
            autoWidth: true,
            clones: 3,
            perPage: 1.2,
            perMove: 1.2,
            gap: '16px',
            autoScroll: {
                speed: speed,
            },
            drag: 'free',
            dragMinThreshold: 0,
            snap: false,
            easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
            trimSpace: false,
        }).mount(window.splide.Extensions);
    });
});
